import Model from "./Model";

export default class Report extends Model {
    static send = async(params) => {
        const startTime = Date.now();
        const res = await this.runQueryNetworkOnly(SendItemReport, params);
        const endTime = Date.now();
        console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@ Report.send.runQuery [COMPLETE]`);
        console.log("res", res);
        console.log(`Send Report Execution time: ${endTime - startTime} ms`);
        return res;
    }

    static sendQRCodeReport = async params => {
        const {propertyUUID, outputComponentQRCodes, destinationEmail } = params;
        const lambdaParams = {
            input: {
                propertyUUID: propertyUUID,
                outputComponents: outputComponentQRCodes,
                destinationEmail: destinationEmail
            }
        };
        await this.runQueryNetworkOnly(SendQRCodesQuery, lambdaParams);
      }
}

const SendItemReport = `
query sendItemReport($input: SendItemReportInput!){
    generateAndSendReportDev(input: $input)
}
`

const SendQRCodesQuery = `
query sendQRCodes($input: QRCodePDFOptionsInput!){
    generateAndSendQRCodes(input: $input)
}`;